import { gql } from '@apollo/client';

export const USERS = gql`
  query users($limit: Int, $page: Int, $search: UserSearchInput) {
    client {
      users(limit: $limit, page: $page, search: $search) {
        totalCount
        list {
          id
          name
          email
          roles {
            id
            roleCode
          }
          employee {
            staffCode
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export interface UsersQueryVariables {
  page?: number | null;
  limit?: number | null;
  search?: UserSearchInput | null;
}

export type SortOrder = 'asc' | 'desc';

export type SortColumn = 'staff_code' | 'full_name_kana' | 'joined_at';

interface UserSearchInput {
  sortOrder?: SortOrder | null;
  sortColumn?: SortColumn | null;
}

export interface Users {
  client: {
    users: {
      totalCount: number;
      list: User[];
    };
  };
}

export interface User {
  id: string;
  name: string;
  email: string;
  roles: Role[];
  employee: Employee | null;
}

export interface Employee {
  staffCode: string;
  firstName: string;
  lastName: string;
}

export interface Role {
  id: string;
  roleCode: RoleCode;
}

export type RoleCode =
  | 'stress_check_practitioner'
  | 'stress_check_person_in_charge'
  | 'regular_health_checkup_user'
  | 'user_manager';
